import React from "react";
import * as util from "../../util";

import Chart from "./charts/chart.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import AnalyticsStore from "../../stores/AnalyticsStore";
import AnalyticsActions from "../../actions/AnalyticsActions";

import SalesDataProcessorWorker from "../../workers/SalesDataProcessor.worker.js";

const PRICE_FORMATTER = (factor = 1) => p =>
  util.formatPrice(p * factor, /* short */ true);

const CHART_OPTIONS = {
  axis: { y: { tick: { format: PRICE_FORMATTER(100) } } },
  point: { show: false }
};

class EventBucketSalesChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      googleHasLoaded: false,
      sales: null,
      weekTable: [],
      dataTable: [],
      runningTable: []
    };
  }

  static getStores() {
    return [AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketSalesById: AnalyticsStore.getEventBucketSalesById
    };
  }

  componentWillMount() {
    AnalyticsActions.fetchEventBucketSales.defer(this.props.eventBucket);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.eventBucket !== this.props.eventBucket) {
      AnalyticsActions.fetchEventBucketSales.defer(newProps.eventBucket);
    }

    let sales =
      this.props.getEventBucketSalesById(this.props.eventBucket) || [];

    if (sales && sales.length && sales !== this.state.sales) {
      this.setState({ sales });

      const worker = new SalesDataProcessorWorker();
      worker.postMessage({ sales });
      worker.addEventListener("message", event => {
        const { weekResult, dataResult, runningResult } = event.data;
        this.setState({ weekResult, dataResult, runningResult });
      });
    }
  }

  render() {
    const { weekResult, dataResult, runningResult } = this.state;

    return (
      <div>
        <Chart
          title="Net sales (last week)"
          type="area"
          indexBy="timeframe.end"
          dateFormat="%b %e"
          chartOptions={CHART_OPTIONS}
          data={weekResult}
        />
        {this.props.showAllTime ? (
          <div>
            <Chart
              title="Net sales (all time)"
              type="area"
              indexBy="timeframe.end"
              dateFormat="%b %e"
              chartOptions={CHART_OPTIONS}
              data={dataResult}
            />
            <Chart
              title="Total net sales (all time)"
              type="area"
              indexBy="timeframe.end"
              dateFormat="%b %e"
              chartOptions={CHART_OPTIONS}
              data={runningResult}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(EventBucketSalesChart);



// WEBPACK FOOTER //
// ./src/app/components/partials/event-bucket-sales-chart.jsx